import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export interface ConnectionStatusSnapshot {
  snapshot_id: number
  clinic_id: number
  broadcast_device_id: number
  snapshot_hour: string
  is_connected: boolean
  last_connected_at: string | null
  created_at: string
}

interface SnapshotResponse {
  data: ConnectionStatusSnapshot[]
  total: number
  page: number
  limit: number
}

interface UseConnectionStatusSnapshotsParams {
  clinicId?: number
  broadcastDeviceId?: number
  startDate?: string
  endDate?: string
  page?: number
  limit?: number
}

export function useConnectionStatusSnapshots(params: UseConnectionStatusSnapshotsParams = {}) {
  const { token } = useAuth()
  const { page = 1, limit = 50, clinicId, broadcastDeviceId, startDate, endDate } = params

  const queryParams: Record<string, unknown> = { page, limit }
  if (clinicId) queryParams.clinicId = clinicId
  if (broadcastDeviceId) queryParams.broadcastDeviceId = broadcastDeviceId
  if (startDate) queryParams.startDate = startDate
  if (endDate) queryParams.endDate = endDate

  const { data, error, mutate } = useGet<SnapshotResponse>(
    token ? '/api/connection-status-snapshots' : null,
    queryParams,
    token ?? '',
  )

  const total = data?.total ?? 0
  const totalPages = Math.ceil(total / limit)

  return {
    snapshots: data?.data,
    pagination: data
      ? {
          page: data.page,
          limit: data.limit,
          total,
          totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
